import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext, useEffect, useRef, } from "react";
import styles from "./sidebar.module.scss";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import { DEFAULT_STOCK_INFO_DATA } from "src/utils/constant";
import { NavPaths } from "../../config/routes";
import { ThemeContext } from "../../contexts/theme-context";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { closeMomentumFullscreen } from "../../redux/reducers/modals";
import { getCurrentDomainPath } from "src/utils/methods";
import { setRefreshGlobalCalled } from "src/redux/reducers/common-reducer";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { captureCleverTabAnalytics } from "src/utils/analytics";
const { REACT_APP_ENV } = process.env;
const Sidebar = () => {
    const dispatch = useAppDispatch();
    // const navigate = useNavigate();
    const value = useContext(ThemeContext);
    const refreshGlobalCalled = useAppSelector((state) => state.commonReducer.refreshGlobalCalled);
    const isPredefinedEnabled = useAppSelector((state) => state.commonReducer.isPredefined);
    const location = useLocation();
    const navigate = useNavigate();
    const navUrlRef = useRef(undefined);
    // useLayoutEffect(() => {
    // });
    const isActive = (path) => {
        if (location.pathname.includes(path)) {
            return true;
        }
        if (path == NavPaths.dashboard &&
            (location.pathname == "/" || location.pathname == NavPaths.momentum)) {
            return true;
        }
        return false;
    };
    // const selectedExpiryData = useAppSelector((state) => {
    //   return state.modals.selectedExpiry;
    // });
    // if (selectedExpiryData.length == 0) {
    //   if (!location.pathname.includes(NavPaths.chain)) {
    //     dispatch(closeSelectedExpiry());
    //   }
    // }
    const renderTooltip = useCallback((toolname) => {
        return _jsx(Tooltip, Object.assign({ className: "sidetooltip" }, { children: toolname }));
    }, []);
    const onSidebarClick = (page, searchQuery) => {
        page = page.substring(1, page.length);
        if (REACT_APP_ENV == "production") {
            dispatch(setRefreshGlobalCalled(true));
            if (searchQuery) {
                // dispatch(stockInfoData(data));
                // navigate({
                //   pathname: page,
                //   search: `?${searchQuery}`,
                // });
                navUrlRef.current = getCurrentDomainPath() + page + `?${searchQuery}`;
            }
            else {
                navUrlRef.current = getCurrentDomainPath() + page;
                // navigate({
                //   pathname: page,
                // });
                // window.location.replace(getCurrentDomainPath() + page);
            }
        }
        else {
            if (searchQuery) {
                // dispatch(stockInfoData(data));
                navigate({
                    pathname: page,
                    search: `?${searchQuery}`,
                });
            }
            else {
                navigate({
                    pathname: page,
                });
            }
        }
        // window.location.reload();
        // dispatch(setCurrentPage(page));
    };
    useEffect(() => {
        if (!refreshGlobalCalled && navUrlRef.current != undefined) {
            window.location.replace(navUrlRef.current);
            navUrlRef.current = undefined;
        }
    }, [refreshGlobalCalled]);
    return (_jsxs("div", Object.assign({ className: `${styles.sbWrapper}` }, { children: [_jsx(OverlayTrigger, Object.assign({ placement: "right", overlay: renderTooltip("Overview") }, { children: _jsx("span", { className: `${styles.sbOverviewIcon} ${isActive(NavPaths.dashboard) ? styles.active : ""} `, onClick: () => {
                        onSidebarClick(NavPaths.home);
                        dispatch(closeMomentumFullscreen());
                    } }) })), _jsx(OverlayTrigger, Object.assign({ placement: "right", overlay: renderTooltip("Option Chain") }, { children: _jsx("span", { className: `${styles.sbChainIcon} ${isActive(NavPaths.chain) ? styles.active : ""}`, onClick: () => onSidebarClick(NavPaths.chain) }) })), _jsx(OverlayTrigger, Object.assign({ placement: "right", overlay: renderTooltip("Open Interest") }, { children: _jsx("span", { className: `${styles.sbOpenInterestIcon} ${isActive(NavPaths.openInterest.index) ? styles.active : ""}`, onClick: () => onSidebarClick(NavPaths.openInterest.oiDashboard) }) })), _jsx(OverlayTrigger, Object.assign({ placement: "right", overlay: renderTooltip("Idea") }, { children: _jsx("span", Object.assign({ className: `${styles.sbIdeasIcon} ${isActive(NavPaths.ideas.index) ? styles.active : ""}`, onClick: () => onSidebarClick(NavPaths.ideas.Equity) }, { children: _jsx("span", Object.assign({ className: "newBadge" }, { children: "New" })) })) })), _jsx(OverlayTrigger, Object.assign({ placement: "right", overlay: renderTooltip("Fno-Stats") }, { children: _jsx("span", { className: `${styles.sbFnoIcon} ${isActive(NavPaths.fnoStats.index) ? styles.active : ""}`, onClick: () => onSidebarClick(`${NavPaths.fnoStats.futActivity}`) }) })), _jsx(OverlayTrigger, Object.assign({ placement: "right", overlay: renderTooltip("Strategy Chart") }, { children: _jsx("span", { className: `${styles.sbStraddleChartIcon} ${isActive(NavPaths.StraddleChart) ? styles.active : ""}`, onClick: () => {
                        onSidebarClick(NavPaths.StraddleChart);
                        captureCleverTabAnalytics("strategycharts clicked", {
                            eventName: "strategycharts clicked",
                        });
                    } }) })), true && (_jsx(OverlayTrigger, Object.assign({ placement: "right", overlay: renderTooltip("Strategies") }, { children: _jsx("span", { className: `${styles.sbStrategisIcon} ${isActive("/preStrategyV1") ? styles.active : ""}`, onClick: () => onSidebarClick("/preStrategyV1") }) }))), _jsx(OverlayTrigger, Object.assign({ placement: "right", overlay: renderTooltip("Company Info") }, { children: _jsx("span", { className: `icon-stock-info ${styles.sbStockInfoIcon} ${isActive(NavPaths.stockInfo) ? styles.active : ""}`, onClick: () => onSidebarClick(NavPaths.stockInfo, createSearchParams(DEFAULT_STOCK_INFO_DATA)) }) })), _jsx(OverlayTrigger, Object.assign({ placement: "right", overlay: renderTooltip("Fii Dii") }, { children: _jsx("span", { className: `${styles.sbfiiIcon} ${isActive(NavPaths.fiiDii) ? styles.active : ""}`, onClick: () => onSidebarClick(NavPaths.fiiDii) }) }))] })));
};
export default Sidebar;
